import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableApp = Loadable({
  loader: function loader() {
    return import('../App.jsx');
  },
  loading: ComponentLoading
});
export default LoadableApp;